import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import {
  Reimbursement,
  AddReimburse,
  DetailReimburse,
  EditReimburse,
} from "./pages";

const reimburseRoutes = [
  {
    path: "/finance/reimbursement",
    element: (
      <ProtectedRoute name="reimbursement">
        <Reimbursement />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="reimbursement"
        defaultTitle="reimbursement.title"
      />
    ),
    children: [
      {
        path: "/finance/reimbursement/add",
        element: <AddReimburse />,
        breadcrumb: null,
      },
      {
        path: "/finance/reimbursement/detail/:reimbursementId",
        element: <DetailReimburse />,
        breadcrumb: null,
      },
      {
        path: "/finance/reimbursement/edit/:reimbursementId",
        element: <EditReimburse />,
        breadcrumb: null,
      },
    ],
  },
];

export default reimburseRoutes;
